import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';

// Components
import { setResolution } from 'components/collage/CollageSlice.js'
import NumericInput from 'react-numeric-input';

// CSS
import './ResolutionChanger.css';

// Images
import CloseIcon from 'img/icons/x.svg';
import RatioLock from 'img/icons/ratio-lock.svg';

Modal.setAppElement('#root');

class ResolutionChanger extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: this.props.collage.resolution.width,
      height: this.props.collage.resolution.height,
      ratioLocked: true
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ( !prevProps.open && this.props.open ) {
      this.setState({
        width: this.props.collage.resolution.width,
        height: this.props.collage.resolution.height
      });
    }
  }

  calculateRatioWidth(height) {

     // Calculate what width will be at new height
     let calculatedWidth = Math.round(height * this.props.collage.resolution.ratio.multiplierHeight);

     // If calculated width is bigger than max pixel size, force it to be max pixel size then resize height accordingly
     if ( calculatedWidth > this.props.collage.maxPixelSize ) {
       
       calculatedWidth  = this.props.collage.maxPixelSize;
       height           = (calculatedWidth * this.props.collage.resolution.ratio.multiplierWidth);

     }

     return {
       width: calculatedWidth,
       height: height
     }

  }

  calculateRatioHeight(width) {
    
    // Calculate what height will be at new width
    let calculatedHeight = Math.round(width * this.props.collage.resolution.ratio.multiplierWidth);

    // If calculated height is bigger than max pixel size, force it to be max pixel size then resize width accordingly
    if ( calculatedHeight > this.props.collage.maxPixelSize ) {
      
      calculatedHeight  = this.props.collage.maxPixelSize;
      width             = (calculatedHeight * this.props.collage.resolution.ratio.multiplierHeight);

    }

    return {
      width: width,
      height: calculatedHeight
    }

  }

  handleRatioLockClick = () => {

    // If is currently not locked, then it's about to be unlocked
    if ( !this.state.ratioLocked ) {

      // If is portrait
      if ( this.state.height > this.state.width ) {
        this.setState({
          ratioLocked: true,
          ...this.calculateRatioWidth(this.state.height)
        });
      }
      else {
        this.setState({
          ratioLocked: true,
          ...this.calculateRatioHeight(this.state.width)
        });
      }

    }
    else {
      this.setState({
        ratioLocked: false
      });
    }
    
  }

  onWidthInputChange = (inputWidth) => {

    let calculatedHeight  = this.state.height;

    // If width is bigger than max pixel size, force it to be max pixel size
    if ( inputWidth > this.props.collage.maxPixelSize ) {
      inputWidth = this.props.collage.maxPixelSize;
    }

    if ( this.state.ratioLocked ) {

      // Calculate what height will be at new width
      // calculatedHeight = this.calculateRatioHeight(inputWidth);

      this.setState(
        this.calculateRatioHeight(inputWidth)
      );

    }
    else {
      this.setState({
        width: inputWidth,
        height: calculatedHeight
      });
    }

    

  }

  onHeightInputChange = (inputHeight) => {

    let calculatedWidth = this.state.width;

    // If height is bigger than max pixel size, force it to be max pixel size
    if ( inputHeight > this.props.collage.maxPixelSize ) 
      inputHeight = this.props.collage.maxPixelSize;
    
    if ( this.state.ratioLocked ) {

      this.setState(
        this.calculateRatioWidth(inputHeight)
      );
      
    }
    else {
      this.setState({
        width: calculatedWidth,
        height: inputHeight
      });
    }


  }

  handleDoneClick = (event) => {
    this.props.onCloseClick();
    this.props.setResolution({
      width: this.state.width,
      height: this.state.height
    });
  }

  render() {

    let lockedClass = ['ButtonReset', 'ButtonLockRatio', 'ButtonGreyHover'];
    let lockTitle   = 'Lock dimensions at ' + this.props.collage.resolution.ratio.name + ' aspect ratio';

    if ( this.state.ratioLocked ) {
      lockedClass.push('ButtonLockRatio--Locked');
      lockTitle = 'Unlock ratio for a custom dimension';
    }


    return (
      <Modal
        isOpen={this.props.open}
        style={{
          overlay: {
            background: 'rgba(255, 255, 255, 0.85)',
            display: 'flex',
            justifyContent: this.props.collage.mode == 'sm' ? 'center' : 'flex-end',
            alignItems: 'flex-start',
            zIndex: 99
          },
          content: {
            background: '#1e1e1e',
            position: 'relative',
            width: window.innerWidth < 768 ? 220 : 480,
            height: window.innerWidth < 768 ? 300 : 120,
            inset: this.props.collage.mode == 'sm' ? '20px' : '20px -200px'
          }
        }}
      >
        <div className={'ResolutionEdit'}>
          <p>Edit Dimensions</p>
          {/* <p>This will be the resolution of the collage image you save.</p> */}

          <div className="ResolutionForm">

            <div className="PixelInput">
              <label className="ResolutionLabel" for="edit-resolution-width"><span aria-hidden="true">W:</span><span class="sr-only">Width:</span></label>
              <div>
                <p>Max: {this.props.collage.maxPixelSize}</p>
                <NumericInput
                  min="0"
                  max={this.props.collage.maxPixelSize}
                  strict={true}
                  value={this.state.width} 
                  id="edit-resolution-width"
                  onChange={this.onWidthInputChange}
                  format={(num) => {
                    return num + ' px';
                  }}
                />
              </div>
            </div>

            <button 
              className={lockedClass.join(' ')}
              onClick={this.handleRatioLockClick}
              title={lockTitle}
            >
              <img src={RatioLock} className="RatioLock" alt="By" />
            </button>

            <div className="PixelInput">
              <label className="ResolutionLabel" for="edit-resolution-height"><span aria-hidden="true">H:</span><span class="sr-only">Height:</span></label>
              <div>
                <p>Max: {this.props.collage.maxPixelSize}</p>
                <NumericInput
                  min="0"
                  max={this.props.collage.maxPixelSize}
                  strict={true}
                  value={this.state.height} 
                  id="edit-resolution-height"
                  onChange={this.onHeightInputChange}
                  format={(num) => {
                    return num + ' px';
                  }}
                />
              </div>
            </div>

            <button 
              className="Button"
              onClick={this.handleDoneClick}
              title="Confirm resolution change"
            >
              Done
            </button>
          </div>
          <button 
            className="ButtonReset ButtonClose"
            onClick={() => this.props.onCloseClick()}
          >
            <img src={CloseIcon} />
          </button>
          {/* <p>Current Ratio: 1:1</p> */}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setResolution}
)(ResolutionChanger)
